export const parseQOLOverTimeGraph = (data) => {
  return data?.reduce(
    (
      acc,
      {
        createdAt,
        physicalBurdenScore,
        emotionalBurdenScore,
        fatigueBurdenScore,
      }
    ) => {
      const date = new Date(createdAt).toLocaleDateString('en-US', {
        month : 'short',
        year  : 'numeric',
      });

      acc.date.push(date);
      acc.physicalBurdenScore.push(physicalBurdenScore);
      acc.emotionalBurdenScore.push(emotionalBurdenScore);
      acc.fatigueBurdenScore.push(fatigueBurdenScore);

      return acc;
    },
    {
      date                 : [],
      physicalBurdenScore  : [],
      emotionalBurdenScore : [],
      fatigueBurdenScore   : [],
    }
  );
};
